module.exports = __webpack_public_path__ + "static/img/txt-4-1.0e51917.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zbqfBrand/txt-4-1.png
// module id = YwnR
// module chunks = 0